import { Box, Typography, useTheme } from '@mui/material'
import { Handle, Position } from '@xyflow/react'
import ErrorIcon from '@mui/icons-material/Error';
import TooltipStatusTitle from '../../../../../components/TooltipStatusTitle';
import CheckHandleNodeEvent from '../../../../../utils/CheckHandleNodeEvent';
import { CustomTooltip } from '../../../../../components/TooltipCustomStyle';

const init = {
    data: {
        general_properties: {
            label: '',
            descriptoin: '',
            subjectConstraints: [],
            action: ''
        },
        error_text: ["General properties incomplete. Please complete them."],
        restfulapi_parent_node: 'node_id',
        router_parent_node: 'node_id'
    },
};

function PathNode({ data, selected }) {

    const theme = useTheme();

    // let labelPath = '';
    // if (data?.general_properties?.action) {
    //     labelPath = `${data?.general_properties?.action} /${data?.general_properties?.label}`;
    // } else {
    //     labelPath = `/${data?.general_properties?.label}`;
    // }

    let methodColor = '';
    if (data?.general_properties?.action === 'GET') {
        methodColor = '#28a745';
    } else if (data?.general_properties?.action === 'POST') {
        methodColor = '#fd7e14';
    } else if (data?.general_properties?.action === 'PUT') {
        methodColor = '#007bff';
    } else if (data?.general_properties?.action === 'DELETE') {
        methodColor = '#dc3545';
    } else {
        methodColor = 'rgb(37,99,235)';
    }

    return (
        <div
            // className='min-w-[160px] h-6 bg-white border border-gray-400 rounded-sm px-2 justify-center items-left flex flex-col relative cursor-pointer'
            className={`min-w-[160px] h-12 relative bg-white w-full rounded-sm border flex flex-col justify-center items-left px-3`}
            style={{
                // borderColor: selected ? methodColor : '#D1D5DB',
                borderColor: data?.general_properties?.action ? methodColor : '#D1D5DB'
            }}
        >
            {/* <div className='flex justify-left items-left'>
                <Typography
                    variant="subtitle1"
                    color='gray'
                    fontSize={{
                        lg: 12,
                        md: 10,
                        sm: 10,
                        xs: 10
                    }}
                    sx={{
                        cursor: 'pointer',
                    }}
                >
                    {labelPath}
                </Typography>
            </div> */}
            <div>
                <Typography
                    variant='subtitle2'
                    fontSize={{
                        lg: 12,
                        md: 10,
                        sm: 10,
                        xs: 10
                    }}
                    sx={{
                        cursor: 'pointer',
                    }}
                >
                    /{data?.general_properties?.label}
                </Typography>
            </div>
            <div>
                <Typography
                    variant="subtitle2"
                    fontSize={{
                        lg: 12,
                        md: 10,
                        sm: 10,
                        xs: 10
                    }}
                    sx={{
                        cursor: 'pointer',
                    }}
                    color={methodColor}
                >
                    {data?.general_properties?.action}
                </Typography>
            </div>
            {data?.error_text.length > 0 &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        right: '5%',
                        transform: 'translate(-50%, 0)',
                        zIndex: 1000,
                        textAlign: 'center',
                    }}
                >
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={data?.error_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.error.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </div>
            }
            {/* <Handle position={Position.Left} type="target" />
            <Handle position={Position.Right} type="source" /> */}
            <Handle
                id="left-target"
                type="target"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected)}
            />
            <Handle
                id="right-source"
                type="source"
                position={Position.Right}
                style={CheckHandleNodeEvent(data, selected)}
            />
        </div>
    )
}

export default PathNode